import { FormattedMessage, FormattedDate } from 'react-intl';
import { MoneyNoDecimals } from '../../../../ui/moneyNoDecimals/MoneyNoDecimals';
import { Tooltip } from '../../../../ui/tooltip/Tooltip';
import { ChooseLoanAmount } from '../../../../sharedDashboardComponents/slider/chooseLoanAmount/ChooseLoanAmount';
import messages from './CustomiseOffer.messages';
import styles from './CustomiseOffer.module.css';
import { MIN_DRAWDOWN_AMOUNT } from '../../../../minDrawdownAmount';

export const CustomiseOffer = ({
    drawdownAmount,
    maxCashAmount,
    approvalStatusTimeOut,
    setDrawdownAmount,
    setNewCalculationRequired
}: {
    drawdownAmount: number;
    setDrawdownAmount: (drawdownAmount: number) => void;
    setNewCalculationRequired: (newCalculationRequired: boolean) => void;
    newCalculationRequired: boolean;
    maxCashAmount: number;
    approvalStatusTimeOut: string;
}) => {
    return (
        <>
            <ChooseLoanAmount
                className={styles.loanAmountSelection}
                setDrawdownAmount={setDrawdownAmount}
                drawdownAmount={drawdownAmount}
                minimumDrawdownAmount={MIN_DRAWDOWN_AMOUNT}
                maximumDrawdownAmount={maxCashAmount}
                setNewCalculationRequired={setNewCalculationRequired}
                label={messages.borrowAmountHeader}
                inputTooltip={
                    <Tooltip
                        data-action-name="Input tooltip"
                        className={styles.inputTooltip}
                        message={
                            <FormattedMessage
                                {...messages.inputTooltip}
                                values={{
                                    amount: (
                                        <MoneyNoDecimals
                                            value={maxCashAmount}
                                        />
                                    ),
                                    date: (
                                        <FormattedDate
                                            value={
                                                new Date(
                                                    approvalStatusTimeOut
                                                ) || new Date()
                                            }
                                            day="2-digit"
                                            month="long"
                                            year="numeric"
                                        />
                                    )
                                }}
                            />
                        }
                    />
                }
            />
        </>
    );
};
